<!-- eslint-disable import/no-self-import -->
<script setup>
import { v7 as uuidv7 } from 'uuid';
import {
  computed,
  defineAsyncComponent,
  toRefs,
} from 'vue';
import { useRoute } from 'vue-router';
import ListItem from './ListItem.vue';

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  prependIcon: {
    type: String,
    default: '',
  },
  children: {
    type: [Array, null],
    default: () => ([]),
  },
  open: {
    type: [Array, null],
    default: () => ([]),
  },
  name: {
    type: [Array, null],
    default: () => ([]),
  },
});

const {
  children,
  open,
  value,
  name,
} = toRefs(props);
const route = useRoute();

const ItemListGroup = defineAsyncComponent(() => import('./ItemListGroup.vue'));
const id = uuidv7();

const list = computed(() => (children.value || []).map((item, index) => {
  let components = ListItem;

  if (item?.children?.length) {
    components = ItemListGroup;
  }

  return {
    ...item,
    key: `${id}-${index}`,
    components,
    children: item.children || [],
  };
}));

defineOptions({
  inheritAttrs: false,
});

const isActive = computed(() => name.value.includes(route.name));

</script>
<template>
  <v-list-group :value="value">
    <template v-slot:activator="{ props }">
      <v-list-item
        v-bind="props"
        :active="isActive"
        :title="title"
        :prepend-icon="prependIcon"
      ></v-list-item>
    </template>

    <component
      v-for="item in list"
      :open="open"
      :key="item.key"
      :is="item.components"
      :to="item.to"
      :title="item.title"
      :value="item.value"
      :name="item.name"
      :children="item.children"
      :prepend-icon="item.prependIcon"
    />
  </v-list-group>
</template>
